import { FileMetaData } from '../../data/models'
import { EInvoiceStatusTag } from './EInvoiceStatusTag'

export const EInvoiceStatusBodyTemplate = (
  status: FileMetaData['status'] | undefined,
) => {
  if (!status) return null

  return <EInvoiceStatusTag status={status} />
}
